import { usePrefixedSelector } from '../usePrefixedSelector';
/**
 * Wrapper for `useSelector` of state that is only used inside the
 * library / prefixed with lib
 *
 * @param selector the selector function
 * @param equalityFn the function that will be used to determine equality
 * @returns the selected state
 */
export function useLibrarySelector(selector, equalityFn) {
    return usePrefixedSelector('lib', selector, equalityFn);
}
//# sourceMappingURL=useLibrarySelector.js.map